import { render, staticRenderFns } from "./EditProductionModal.vue?vue&type=template&id=59b21512&scoped=true&"
import script from "./EditProductionModal.vue?vue&type=script&lang=js&"
export * from "./EditProductionModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProductionModal.vue?vue&type=style&index=0&id=59b21512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b21512",
  null
  
)

export default component.exports